export default {
  async getUserData() {
    const response = await fetch(process.env.VUE_APP_TOKEN_AUTH_URL);
    return response.json();
  },
  async refreshToken() {
    return await fetch(process.env.VUE_APP_TOKEN_REFRESH_URL);
  },
};